<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '~/lib/utils'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import { type ButtonVariants, buttonVariants } from '.'
import { Icon } from '@iconify/vue'

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  isLoading?: boolean
  disabled?: boolean
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
  isLoading: false,
  disabled: false,
})
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :disabled="disabled || isLoading || undefined"
    :class="cn(buttonVariants({ variant, size }), props.class)"
  >
    <Icon v-if="isLoading" icon="lucide:loader-circle" class="w-5 h-5 mr-2 animate-spin" />
    <slot />
  </Primitive>
</template>
